import { Box, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Select, Tooltip } from '@chakra-ui/react'
import React from 'react'
import CustomButton from '../../../../elements/customButton'
import { InfoOutlineIcon } from '@chakra-ui/icons'
import moment from 'moment'
import CustomToast from '../../../../elements/customToast'

export default function ForclosePaymentDiaglog(props) {
    const { addToast } = CustomToast()
    const totalOutstandingAmount = props?.data?.loanContract[0]?.total_outstanding_dues
    const repaymentDate = props?.data?.maturity_date && moment(props?.data?.maturity_date).format("DD/MM/YYYY")
    const interestAmount = props?.data?.loanContract[0]?.accured_interset_till_date
    const partPaymentOptions = props?.data?.part_payment && Object.keys(props?.data?.part_payment).map((key) => ({
        id: key,
        name: key + " - " +props?.data?.part_payment[key]
    }));
    const partPayValue = props?.inputValues?.part_amount?.replace(/^\d+ - /, '')

    const handlePaymentModal = () => {
        props.handleOpenLoanPaymentDialog(props?.forclose_data_res?.total_foreclosure_amount ?? "NA")
    }

    const PopupBox = () => (
        <Box>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader className="payment_title font-poppins">Foreclose Your Loan</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Box className='d-flex align-items-center justify-content-between col-gap-15' mb={4}>
                        <Box className='form_inputs'>
                            <Heading as="h5" className='font-poppins'> Foreclose Principal Amount</Heading>
                            <Input size="md" type="text" className="input_box font-poppins" disabled value={props?.forclose_data_res?.foreclosure_principal_amount ?? "NA"}
                            />
                        </Box>
                        <Box className='form_inputs'>
                            <Heading as="h5" className='font-poppins'>Accrued Interest</Heading>
                            <Input size="md" type="text" className="input_box font-poppins" disabled value={`₹ ${props?.forclose_data_res?.accrued_interest ?? "NA"}`} />
                        </Box>
                    </Box>
                    <Box className='form_inputs' mb={4}>
                        <Heading as="h5" className='font-poppins'>Penal Interest</Heading>
                        <Input size="md" type="text" className="input_box font-poppins" disabled value={`${props?.forclose_data_res?.penal_interest ?? "NA"}`} />
                    </Box>
                    <Box className='form_inputs' mb={4}>
                        <Heading as="h5" className='font-poppins'>Foreclosure Chargers</Heading>
                        <Input size="md" type="text" className="input_box font-poppins" disabled value={`${props?.forclose_data_res?.foreclosure_charges ?? "NA"}`} />
                    </Box> 
                    <Box className='form_inputs' mb={4}>
                        <Heading as="h5" className='font-poppins'>GST(18%)</Heading>
                        <Input size="md" type="text" className="input_box font-poppins" disabled value={`${props?.forclose_data_res?.foreclosure_gst ?? "NA"}`} />
                    </Box>
                    <Box className='form_inputs' mb={4}>
                        <Heading as="h5" className='font-poppins'>Total Foreclosure Amount</Heading>
                        <Input size="md" type="text" className="input_box font-poppins" disabled value={`${props?.forclose_data_res?.total_foreclosure_amount ?? "NA"}`} />
                    </Box>
                    <Box className='d-flex align-items-center justify-content-end col-gap-15' mb={4}>
                        {/* <CustomButton size="md" type="submit" title="Cancel" className="btn_theme_transparent" onClick={props.handleClosePartPayDialog} /> */}
                        <CustomButton size="md" type="submit" title="Pay" className="btn_theme" onClick={handlePaymentModal} />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Box>
    )

  return (
    <Modal
        isCentered
        isOpen={props.forclosePayment}
        onClose={props.handleCloseSidebar}
        motionPreset="slideInBottom"
        size={'xl'}
    >
    {PopupBox()}
    </Modal>
  )
}
